import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=a002580c&scoped=true&"
import script from "./distributionList.vue?vue&type=script&lang=js&"
export * from "./distributionList.vue?vue&type=script&lang=js&"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=a002580c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a002580c",
  null
  
)

export default component.exports